import * as $ from "jquery";
import { Grid } from 'ag-grid-community';

export default class UsersComponent {
    constructor() {
        this.componentSelector = "#backoffice-users";
        this.grid = null;
        this.instance = this;
    }

    init() {
        let instance = this;
        if ($(instance.componentSelector).length > 0) {
            instance.bind();
        }
    }

    bind() {
        let instance = this;
        instance.search(instance);

        $('.js-update-role').off().on('click', function () {
            instance.updateRole(instance);
        });
    }

    search(instance) {
        axios({
            method: 'post',
            url: "/user/backofficeusers",
            data: {}
        }).then(function (response) {
            console.log(JSON.parse(response.data));
            instance.render(instance, JSON.parse(response.data));
        }).catch(function (response) {
        });
    }

    buttonRenderer(params) {
        var button = document.createElement('button');
        button.innerHTML = 'Byt lösenord';
        button.addEventListener('click', function () {

            bootbox.prompt({
                title: "Byt lösenord",
                message: "Ange nytt lösenord för: " + params.data.Name,
                callback: function (result) {
                    if (result != "") {
                        axios({
                            method: 'post',
                            url: "/user/BackofficeUserChangePassword",
                            data: { id: params.data.Id, password: result }
                        }).then(function (response) {
                            bootbox.alert("Lösenordet är ändrat.")
                        }).catch(function (response) {
                        });
                    }
                }
            });
        });
        return button;
    }

    updateEmailRenderer(params) {
        var button = document.createElement('button');
        button.innerHTML = 'Uppdatera email';
        button.addEventListener('click', function () { 
            
            bootbox.prompt({
                title: "Uppdatera email",
                message: "Uppdatera email för: " + params.data.Name,
                callback: function (result) {
                    if (result != "") {
                        axios({
                            method: 'post',
                            url: "/user/BackofficeUserChangeEmail",
                            data: { id: params.data.Id, email: result }
                        }).then(function (response) {
                            bootbox.alert("Mailadressen är uppdaterad.")
                            params.context.search(params.context);
                        }).catch(function (response) {
                        });
                    }
                }
            });
            
        });
        return button;
    }

    updateRolesRenderer(params) {
        var button = document.createElement('button');
        button.innerHTML = 'Roller';
        button.addEventListener('click', function () {
            params.context.showModal(params.value, params.data, params.context);
        });
        return button;
    }

    showModal(values, data, instance) {
        console.log(data);

        $('.modal-body').attr('data-userid', data.Id);

        $('#user-roles input:checkbox').prop('checked', false)
        $.each($('#user-roles input:checkbox'), function () {
            var roleName = $(this).attr('data-role');
            var checkbox = this;
            $.each(data.UserRoles, function () {
                if (this == roleName) {
                    $(checkbox).prop('checked', true)
                }
            });
        });

        setTimeout("$('#edit-modal').modal('show');", 10);
    }

    updateRole(instance) {
        let userId = $('.modal-body').attr('data-userid');
        var roles = "";

        $.each($('#user-roles input:checkbox'), function () {
            if ($(this).is(":checked")) {
                roles += $(this).attr('data-id') + ",";
            }
        });

        axios({
            method: 'post',
            url: "/user/BackofficeUserUpdateRoles",
            data: { id: userId, roles: roles }
        }).then(function (response) {
            console.log(JSON.parse(response.data));
            instance.search(instance);
            setTimeout("$('#edit-modal').modal('hide');", 10);
        }).catch(function (response) {
            bootbox.alert("Ett fel inträfface.");
        });
    }

    loadModal(id) {

        bootbox.prompt({
            title: "Byt lösenord",
            message: "Ange nytt lösenord",
            inputType: 'string',
            callback: function (result) {

            }
        });
    }

    render(instance, data) {

        if (instance.grid == null) {
            instance.grid = {
                context: instance,
                columnDefs: [
                    {
                        headerName: 'Id', field: 'Id',
                        width: 100,
                    },
                    { headerName: 'Namn', field: 'Name' },
                    { headerName: 'Seller Id', field: 'SellerId' },
                    { headerName: 'Användarnamn', field: 'UserName' },
                    { headerName: 'Email', field: 'Email' },
                    {
                        headerName: 'Roller',
                        field: 'UserRolesFormatted',
                        width: 300
                    },
                    {
                        headerName: "",
                        field: 'Id',
                        cellRenderer: instance.buttonRenderer,
                        width: 120,
                    }, {
                        headerName: "",
                        field: 'Id',
                        cellRenderer: instance.updateEmailRenderer,
                        width: 150,
                    }, {
                        headerName: "",
                        field: 'Id',
                        cellRenderer: instance.updateRolesRenderer,
                        width: 150,
                    }
                ],
                rowData: data,
                defaultColDef: { sortable: true, filter: true },
                domLayout: 'autoHeight'
            };

            var eGridDiv = document.querySelector('#report');
            new Grid(eGridDiv, instance.grid);
        }
        else {
            instance.grid.api.setRowData(data);
        }
    }
}